import client from '@util/api'
import { ProviderModel } from '@provider/typing'
import { PROVIDERS } from '../../../route.const'
import {
  ProviderProfile,
  ProviderUpdate,
} from '@provider/context/ProviderProfileProvider/typing'

export const loadProviderProfile = async () => {
  const response = await client.get<ProviderProfile>(`/${PROVIDERS}/profile/`)
  return response.data
}

export const loadProvider = async () => {
  const response = await client.get<ProviderModel>(`/${PROVIDERS}`)
  return response.data
}

export const deactivateProfile = async () => {
  const response = await client.delete(`/${PROVIDERS}/`)
  return response.data
}

export const editProfile = async (profile: ProviderUpdate) => {
  const response = await client.patch<ProviderModel>(`/${PROVIDERS}/`, {
    ...profile,
  })
  return response.data
}
